module.exports = __webpack_public_path__ + "static/media/arrow-square-left.b3c606ad.svg";